module.exports = __webpack_public_path__ + "static/media/winter_discovery_pack_dog_FR.7d2efde5.png";